import React from 'react';

interface TabLoadingSpinnerProps {
  label?: string;
}

const TabLoadingSpinner: React.FC<TabLoadingSpinnerProps> = ({ label = 'Loading' }) => (
  <div className="flex items-center justify-center h-64" role="status" aria-label={label}>
    <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
  </div>
);

export default TabLoadingSpinner;
